import { buildVenueAnalysisStreamSlice } from 'widgets/venueAnalysis/store/stream/streamSlice';

const { selectors: liquiditySummaryCapsuleStreamedDataSelectors } =
    buildVenueAnalysisStreamSlice();

export { liquiditySummaryCapsuleStreamedDataSelectors };
